<template>
  <b-col xs="12" lg="12" v-if="model !== null">
    <b-card>
      <b-card no-body>
        <b-tabs card pills vertical nav-wrapper-class="w-40" v-model="tabIndex[1]" lazy>
          <b-tab href="#general" @click="tabChange('general')">
            <template slot="title">
              <i class="icon-screen-desktop"></i> {{ $t('general') }}
            </template>
            <b-form-group :label="$t('uuid')" label-for="basicName" :label-cols="2" :horizontal="true">
              <b-form-input id="uuid" type="text" :value="model.uuid" disabled></b-form-input>
            </b-form-group>

            <b-form-group :label="$t('name')" label-for="basicName" :label-cols="2" :horizontal="true">
              <b-input-group>
                <b-form-input id="name" type="text" v-model="model.name" :disabled="!$isAdmin()"></b-form-input>
                <b-input-group-append v-if="$isAdmin()">
                  <b-button variant="success" @click="saveSettings"> {{ $t('save') }} </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group :label="$t('createdAt')" label-for="basicName" :label-cols="2" :horizontal="true">
              <b-form-input id="name" type="text" :value="$toUserTimeZone(model.CreatedAt)" disabled></b-form-input>
            </b-form-group>

            <!-- <b-form-group
                  v-if="isOwner()"
                  description="Transfer project to another user"
                  :label-cols="2"
                  :horizontal="true">
              <div class="form-action">
                  <b-button variant="primary" @click="transfer">Transfer</b-button>
                  <b-modal title="Transfer project" v-model="transferModal.show" @ok="triggerTransfer" :hide-footer="transferModal.user_uuid == ''">
                    <SelectField v-if="userOnProject.length > 0" label="User" v-model="transferModal.user_uuid" :rules={} :items="userOnProject"/>
                    <p v-else> No users on the project </p>
                  </b-modal>
              </div>
              </b-form-group> -->

            <b-form-group :label-cols="2" :horizontal="true">
              <div class="form-action">
                <b-button variant="danger" v-if="isOwner()" @click="remove">{{ $t('remove') }}</b-button>
                <b-button variant="primary" @click="leave" v-if="!isOwner()">{{ $t('leave') }}</b-button>
              </div>
            </b-form-group>

          </b-tab>
          <b-tab href="#account" @click="tabChange('account')" v-if="isOwner()">
            <template slot="title">
              <i class="fa fa-user"></i> {{ $t('account') }}
            </template>

            <b-tabs>
              <b-tab :title="$t('general')" active>

                <b-form-group :label="$t('account')" label-for="basicName" :label-cols="2" :horizontal="true">
                  <b-form-input id="id" type="text" :value="model.account.name" disabled></b-form-input>
                </b-form-group>

                <b-card>
                  <AccountInfo :account="model.account" :prices="prices" :currency="currency" v-if="prices" />
                  <b-skeleton height="100" animation="throb" v-else />
                </b-card>

                <b-skeleton v-if="!accounts" height="150" animation="throb"></b-skeleton>
                <b-row v-else>
                  <template v-if="availableUpgrades.length > 0">
                    <b-col cols="12">
                      <h4>{{ $t('unlockMoreToday') }}</h4>
                    </b-col>
                    <b-col cols="12" md="4" sm="6" v-for="upgrade in availableUpgrades" :key="upgrade.uuid">
                      <b-card>
                        <h4>{{ upgrade.name }}</h4>
                        <div class="mb-3"><b-form-checkbox switch v-model="accountAnnual"> {{ $t('annually') }}
                          </b-form-checkbox></div>

                        <h3 v-if="accountAnnual">{{ getPriceAndCurrency(upgrade.priceAnnualy()).price }} {{
                          getPriceAndCurrency(upgrade.priceAnnualy()).currency }} <small>{{ $t('billedMonthly')
                            }}</small></h3>
                        <h3 v-else>{{ getPriceAndCurrency(upgrade.priceMonthly()).price }} {{
                          getPriceAndCurrency(upgrade.priceMonthly()).currency }} <small>{{ $t('billedMonthly')
                            }}</small> </h3>

                        <AccountInfo :account="upgrade" :prices="prices" :currency="currency" :key="upgrade.type" />

                        <b-row cols="2" class="mt-4">
                          <b-col><a style="text-decoration:underline" href="mailto:support@protokol.io">{{
                              $t('requestTrial') }}</a></b-col>
                          <b-col><protokol-checkout-button productType="account" :reference="upgrade.uuid"
                              :options="{ variant: accountAnnual ? 'annual' : 'month' }">{{ $t('upgrade')
                              }}</protokol-checkout-button></b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </template>
                </b-row>

              </b-tab>
              <b-tab :title="$t('subscriptions')">
                <Subscription :settings="model.settings" @subscribed="subscribed" />
              </b-tab>
            </b-tabs>
          </b-tab>

          <!-- <b-tab href="#billing" @click="tabChange('billing')" v-if="isOwner()">
            <template slot="title">
              <i class="fa fa-money"></i>{{ $t('billing') }}
            </template>

            <Billing />
          </b-tab> -->

          <b-tab href="#usage" @click="tabChange('usage')" v-if="isOwner()">
            <template slot="title">
              <i class="fa fa-database"></i> {{ $t('usage') }}
            </template>

            <Usage :project="model" />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
  </b-col>
</template>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import Billing from "./Settings/Billing"
import Subscription from "./Settings/Subscription"
import Usage from "./Usage"
import _ from "lodash"
import AccountInfo from './AccountInfo'
import Account from '@/lib/Account'
import Checkout from '@/lib/Checkout'
import BillingInfo from '@/views/users/BillingInfo'
import Price from '@/plugins/protokol/lib/Price'

export default {
  name: "Settings",
  components: {
    InputField: Input,
    SelectField: Select,
    Billing,
    Subscription,
    Usage,
    AccountInfo,
    BillingInfo
  },
  data: function () {
    return {
      info: null,
      revokedSecrets: [],
      tabIndex: [0, 0],
      transferModal: {
        show: false,
        user_uuid: ""
      },
      paymentMethods: [
        {
          name: "Invoice",
          provider: "protokol",
          method: "invoice"
        }
      ],
      tabHash: ["#general", "#account", "#usage", "#credentials"],
      reserveRequestsModal: false,
      reservedRequestsAmount: 0,
      reservedRequestsQty: 10000,
      calculatingPrice: false,
      maxReservedRequests: 0,
      canReserveRequests: false,
      prices: null,
      accounts: null,
      showBillingInformationModal: false,
      billingInfoSaved: false,
      accountAnnual: true
    }
  },
  watch: {
    reservedRequestsQty: function (nVal, oVal) {
      if (!this.calculatingPrice) {
        this.getServicePriceDebounce()
      }
    }
  },
  methods: {
    getServicePrice() {
      this.calculatingPrice = true
      this.$transactionApi.post("/transactions/calculate_price", {
        service: "reserved_requests",
        quantity: this.reservedRequestsQty
      }).then(resp => {
        this.reservedRequestsAmount = resp.data.price / 100
        this.calculatingPrice = false
      }).catch(err => {
        this.calculatingPrice = false
      })
    },

    tabChange(e) {
      window.location.hash = e
    },

    isOwner() {
      return this.model.user_uuid == this.$store.getters.getUser.uuid
    },

    leave() {
      this.$bvModal.msgBoxConfirm("Are you sure?").then(resp => {
        if (resp) {
          this.$http.delete("/v1/project/user/" + this.$store.getters.getUser.uuid).then(resp => {
            //console.log(resp)
            this.$router.go()
          }).catch(error => {
            if (error.response.status == 500) {
              this.$serverErrorModal(error)
              return
            }

            this.$bvModal.msgBoxOk(err.response.data.message)
          })
        }
      })

    },

    remove() {
      this.$bvModal.msgBoxConfirm("Are you sure you want to delete project? This action can not be reverted").then(resp => {
        if (resp) {
          const popup = this.$loadingPopup()
          this.$http.patch("/v1/project/archive").then(resp => {
            //console.log(resp)
            this.$store.commit("REMOVE_PROJECT", this.$store.getters.getCurrentProject.uuid)
            this.$router.push("/?force=true")
          }).catch(error => {
              if (error.response.status == 500) {
                  this.$serverErrorModal(error)
                  return
              }

              this.$bvModal.msgBoxOk(err.response.data.message)
          }).finally(popup.hide)
        }
      })
    },


    getDBSize() {
      if (this.info === null) {
        return 0
      }

      return this.info.db_size
    },

    transfer() {
      this.transferModal.show = true;
    },

    triggerTransfer() {
      this.$bvModal.msgBoxConfirm(this.$t('removedFromProject')).then(resp => {
        if (resp) {
          this.$http.post("/v1/project/transfer", { user_uuid: this.transferModal.user_uuid }).then(resp => {
            this.$router.go("/admin/dashboard")
          }).catch(err => {
            this.$bvModal.msgBoxOk(this.$t('errorDuringTransfer') + err.response.data.message);
          })
        }
      })
    },

    saveSettings() {
      const popup = this.$loadingPopup()
      this.$http.post("/v1/project/settings", this.model).catch(err => {
        this.$bvModal.msgBoxOk(err.response.message);
      }).finally(() => {
        popup.hide()
      })
    },

    reserveRequests() {
      this.reserveRequestsModal = true;
    },

    subscribed(sub) {
      this.model.account = sub.account;
    },

    async attemptUpgradeAccount(account) {
      // check is billing information filled in
      const user = this.$store.getters.getUser
      if (!user.settings.billing_address.country) {
        this.showBillingInformationModal = true
      } else {
        this.upgradeAccount(account)
      }
    },

    async upgradeAccount(account) {
      let checkout = new Checkout()
      const link = await checkout.getCheckoutLink({
        product_type: "account",
        reference: account.uuid,
        lang: this.$store.getters.getLocale,
        options: {
          variant: this.accountAnnual ? 'annual' : 'month'
        }
      })

      window.open(link.data, '_blank')
    },

    billingInfoSave() {
      this.billingInfoSaved = true
    },

    getPriceAndCurrency(price) {
      const { billing_address = {} } = this.$store.getters.getUser.settings
      const { country } = billing_address || {}

      const p = new Price(
        country,
        this.$store.getters.getLocale
      )

      return p.getPriceAndCurrency(price)
    }
  },
  computed: {
    subscriptions() {
      return this.$store.getters.getSubscriptions
    },

    model() {
      return this.$store.getters.project(localStorage.getItem("current_project_uuid"))
    },

    userOnProject() {
      return this.model.users.map(u => {
        return {
          text: u.user.name,
          value: u.user.uuid
        }
      })
    },

    billableRequests() {
      let billable = this.model.api_requests - (this.model.account.api_requests + this.model.reserved_api_requests);

      if (billable <= 0) {
        return 0
      }

      return billable
    },

    billableDBSize() {
      let billable = this.getDBSize() - this.model.account.database_size;

      if (billable <= 0) {
        return 0
      }

      //turn bytes into Megabytes
      return billable / 1024 / 1024;
    },

    balance() {
      if (this.info) {
        return this.info.balance / 100
      }
    },

    freeRequestsPercent() {
      let p = (this.model.api_requests / this.model.account.api_requests) * 100
      if (p > 100) return 100

      return p
    },

    billableRequestsPercent() {
      let p = ((this.model.api_requests - this.model.account.api_requests) / this.model.reserved_api_requests) * 100 - 100
      if (p < 0) return 0;

      return p
    },

    reservedRequestsPercent() {
      let p = ((this.model.api_requests - this.model.account.api_requests) / this.model.reserved_api_requests) * 100
      if (p < 0) return 0;
      if (p > 100) return 100;

      return p
    },

    databaseSize() {
      let gbSize = this.getDBSize() / 1024 / 1024 / 1024
      if (gbSize < 1024 && gbSize > 1) {
        return parseFloat(gbSize.toFixed(2))
      }

      let mbSize = this.getDBSize() / 1024 / 1024
      if (mbSize < 1024 && mbSize > 1) {
        return parseFloat(mbSize.toFixed(2))
      }

      let kbSize = this.getDBSize() / 1024
      if (kbSize < 1024 && kbSize > 1) {
        return parseFloat(kbSize.toFixed(2))
      }

      return parseFloat(this.getDBSize().toFixed(2))
    },

    databaseSizePercent() {
      let p = (this.getDBSize() / this.model.account.database_size) * 100
      if (p > 100) return 100

      return parseInt(p.toFixed(2))
    },

    billableDBSizePercent() {
      let p = (this.getDBSize() / this.model.account.database_size) * 100 - 100
      if (p < 0) return 0;

      return p.toFixed(2)
    },

    databaseSizeSuffix() {
      let size = this.getDBSize();

      let gbSize = size / 1024 / 1024 / 1024
      if (gbSize < 1024 && gbSize > 1) {
        return "GB"
      }

      let mbSize = size / 1024 / 1024
      if (mbSize < 1024 && mbSize > 1) {
        return "MB"
      }

      let kbSize = size / 1024
      if (kbSize < 1024 && kbSize > 1) {
        return "KB"
      }

      return "B"
    },

    minReservedRequests() {
      return 10000
    },

    availableUpgrades() {
      const subscriptions = this.subscriptions || []
      let subAccount = subscriptions.find(s => {
        return s.license_product.group == "Account"
      })

      if (subAccount && subAccount.payment_status == "pending") {
        return []
      }

      const rates = this.$store.getters.getCurrencyRates || {}

      return this.accounts.filter(a => {
        return a.level > this.model.account.level
      }).map(a => {
        return new Account(a, rates)
      }).sort((a, b) => {
        return b.level - a.level
      })
    },

    currency() {
      try {
        const { billing_address = {} } = this.$store.getters.getUser.settings
        const { country } = billing_address || {}

        const p = new Price(
          null,
          this.$store.getters.getLocale
        )

        return p.getCurrency()
      } catch {
        const p = new Price(
          null,
          this.$store.getters.getLocale
        )

        return p.getCurrency()
      }
    }
  },
  created() {
    if (this.model === undefined) {
      this.$router.push({ path: "/admin/dashboard" })
    }

    this.$store.dispatch("fetchProjectInfo").then(data => {
      this.info = data
    }).catch(error => {
      if (error.response !== undefined) {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }
      }
    })

    let hash = window.location.hash
    this.tabIndex = [0, this.tabHash.indexOf(hash)]

    if (this.$route.query.paymentCanceled !== undefined) {
      this.$bvModal.msgBoxOk(this.$t('yourPaymentFailed'))
    }

    if (this.$route.query.paymentSuccess !== undefined) {
      this.$bvModal.msgBoxOk(this.$t('paymentSuccessful'));
    }

    this.$transactions.prices(this.currency).then(resp => {
      this.prices = resp.data
    }).catch(err => {
      this.$debugLog(err)
      this.$bvToast.toast(this.$t('unexpectedError'), {
        variant: 'danger',
        title: this.$t('error')
      })
    })

    this.$http.get("/v1/user/register/accounts").then(resp => {
      this.accounts = resp.data
    }).catch(err => {
      this.$bvToast.toast(this.$t('unexpectedError'), {
        variant: 'danger',
        title: this.$t('error')
      })
    })

    this.$store.dispatch("fetchCurrencyRates")
    this.$store.dispatch("fetchSubscriptions")
  }
}
</script>
